// ---------------------------------------------------------------------------
// Situação do funcionário (`employment_status`) — rótulo + variante da pílula.
//
// FONTE DO ENUM: o <select> de escrita em pages/hr/EmployeeForm, que é quem
// grava o campo — `ATIVO · EXP 1 · EXP 2 · FÉRIAS · DESLIGADO`. `AFASTADO`
// entra porque duas telas de leitura (EmployeeShow, EmployeeDebtsReport) o
// mapeiam: o formulário não oferece mais o valor, mas pode haver registro
// antigo com ele.
//
// ⚠️ Existem HOJE três dicionários paralelos e DIVERGENTES no app
// (EmployeeList usa `EXPERIENCIA`, que o formulário nunca grava; as outras
// duas usam `EXP 1`/`EXP 2`). Este é o canônico; as três telas convergem para
// cá ao serem tocadas — não foram alteradas aqui de propósito (legado migra ao
// ser tocado).
//
// Valor desconhecido NÃO é escondido: cai em neutro exibindo o valor cru, para
// um status novo do backend aparecer em vez de sumir silenciosamente.
// ---------------------------------------------------------------------------

const EMPLOYMENT_STATUS = {
   ATIVO: { label: 'Ativo', variant: 'green' },
   'EXP 1': { label: 'Exp. 1', variant: 'blue' },
   'EXP 2': { label: 'Exp. 2', variant: 'blue' },
   FÉRIAS: { label: 'Férias', variant: 'amber' },
   AFASTADO: { label: 'Afastado', variant: 'amber' },
   DESLIGADO: { label: 'Desligado', variant: 'red' },
};

export default function employmentStatusBadge(status) {
   const value = String(status ?? '').trim();
   if (!value) return null;
   return EMPLOYMENT_STATUS[value] ?? { label: value, variant: 'neutral' };
}
